import { FundDocument } from '../types';
import { useList } from '@refinedev/core';

type FundDocumentsProps = {
  fundId: string;
};
export const useFundDocuments = ({ fundId }: FundDocumentsProps) => {
  const { data, isLoading, refetch, error, isError } = useList<FundDocument>({
    resource: `funds/${fundId}/files`,
  });

  return {
    documents: data?.data || [],
    isLoading,
    refetch,
    error,
    isError,
  };
};
